export default __webpack_public_path__ + "static/media/ic_moonbeam_16.96c21403.svg";